import {
  GET_USER_PREFERENCES_API,
  USER_PREFERENCES_SAVED_FOR_LATER_API,
} from 'config/constants';
import { Modality } from 'types';
import axios from 'axios';

const { get, post } = axios;

export const getUserPreferences = async () => {
  try {
    const response = await get(GET_USER_PREFERENCES_API);
    return response;
  } catch (e) {
    throw e;
  }
};

export const postUserSavedForLaterOffering = async (
  code: string,
  modality: Modality,
  refresh = false,
) => {
  try {
    const request = {
      code,
      modality,
      ...(refresh ? { refresh: true } : {}),
    };
    const response = await post(USER_PREFERENCES_SAVED_FOR_LATER_API, request);
    return response;
  } catch (e) {
    throw e;
  }
};
